/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AppLabInfo } from '../../models/app-lab-info';

export interface AppControllerFindSupportedAppList$Params {
}

export function appControllerFindSupportedAppList(http: HttpClient, rootUrl: string, params?: AppControllerFindSupportedAppList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AppLabInfo>>> {
  const rb = new RequestBuilder(rootUrl, appControllerFindSupportedAppList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AppLabInfo>>;
    })
  );
}

appControllerFindSupportedAppList.PATH = '/app/supportedList';
